/*@ngInject*/
const ComponentEditorController = function ($rootScope, $scope, $element, formViewerConstant, configurationConstant, formMediator, formTemplateStatus,
                                            modalUtil, localization, authorizationConstants, currentUserModel, componentModel) {

    $element.addClass('componentEditor');

    this.translations = {};
    this.canDeleteComponent = false;

    this.$onInit = function () {
        let userCanManageForms = currentUserModel.hasAuthorization(authorizationConstants.MANAGE_FORMS);

        localization.getTranslations().then(function (translations) {
            this.translations = translations;
        }.bind(this));

        // this "if" check should be removed once we refactor row repeaters to be configurable
        if (this.componentStructure.parentUiFormTemplate) {
            this.canDeleteComponent = this.componentStructure.parentUiFormTemplate.formTemplate.id !== this.componentStructure.uiField.fieldTemplate.formTemplateId || userCanManageForms && this.componentStructure.parentUiFormTemplate.formTemplate.status !== formTemplateStatus.IN_PRODUCTION;
        }

        if (!_.isNil(this.componentStructure)) {
            this.componentStructure.selected = componentModel.getSelectedComponentId() === this.componentStructure.originalVariableName;
        }

        if (this.componentStructure.selected) {
            $rootScope.$broadcast(formViewerConstant.configuration.event.FIELD_SELECTION_CHANGE, this.componentStructure);
        }

    };

    this.onDeleteComponentStructure = function () {
        let message = _.get(this.translations, 'componentEditor.deleteComponentConfirmation.summary'),
            title = _.get(this.translations, 'componentEditor.deleteComponentConfirmation.title'),
            cancelButtonLabel = _.get(this.translations, 'genericButtons.cancel'),
            confirmButtonLabel = _.get(this.translations, 'genericButtons.continue');

        function handleClose() {
            formMediator.deleteField(this.rootFormId, this.componentStructure.fieldStructureId);
            $rootScope.$broadcast(formViewerConstant.configuration.event.FIELD_SELECTION_CHANGE, null);
        }

        modalUtil.showGenericConfirm({
            cancelButtonLabel: cancelButtonLabel,
            confirmActionButtonLabel: confirmButtonLabel,
            summary: message,
            title: title
        }).then(handleClose.bind(this));
    };

    $scope.$on(configurationConstant.event.OPTION_GROUP_INPUT_VALUE_CHANGED, function (event, object) {
        if(object.name === 'variableName') {
            componentModel.setSelectedComponentId(object.value);
        }
    }.bind(this));

    $scope.$on(formViewerConstant.configuration.event.FIELD_SELECTION_CHANGE, function (event, componentStructure) {
        if (!_.isNil(componentStructure)) {
            this.componentStructure.selected = componentStructure.originalVariableName === this.componentStructure.originalVariableName;
            componentModel.setSelectedComponentId(componentStructure.uiField.fieldTemplate.variableName);
        } else {
            this.componentStructure.selected = false;
        }
    }.bind(this));

    $scope.$on(formViewerConstant.configuration.event.ROW_SELECTION_CHANGE, function () {
        this.componentStructure.selected = false;
    }.bind(this));

    $scope.$on(formViewerConstant.configuration.event.SECTION_SELECTION_CHANGE, function () {
        this.componentStructure.selected = false;
    }.bind(this));

    $scope.$on(formViewerConstant.configuration.event.ROW_SELECTION_CHANGE, function () {
        this.componentStructure.selected = false;
    }.bind(this));
};

angular.module('umFormViewer')
    .controller('componentEditorController', ComponentEditorController);
